import { isMobile, mqMobile, debounce } from './env';

/*
 * libraryMainsite scale #MS__wrapper + .MS__outer theo CHIỀU NGANG (2000 PC / 768 MB) nhưng:
 *  - chỉ scale ở window.load (muộn) → gọi sớm ngay khi bundle chạy để không thấy layout 2000px trần;
 *  - biến --sr-device-height của bản 1.3.0 không cập nhật khi resize → tự tính --dh (chiều cao màn hình
 *    quy về px thiết kế) và --stage-k (thu nhỏ khung 1000px khi màn hình thấp hơn);
 *  - body chỉ được set chiều cao lúc load/resize → nội dung đổi cao (AJAX, ảnh) sẽ bị cắt mất phần dưới,
 *    nên theo dõi bằng ResizeObserver rồi đồng bộ lại.
 */
const STAGE_H = 1000;
let wrapper;

function designWidth() {
  const ms = window.varMS || {};
  return isMobile() ? ms.scaleWidthMB || 768 : ms.scaleWidthPC || 2000;
}

export function ratio() {
  if (wrapper && wrapper.offsetWidth) {
    const r = wrapper.getBoundingClientRect().width / wrapper.offsetWidth;
    if (r > 0 && Number.isFinite(r)) return r;
  }
  return window.innerWidth / designWidth();
}

function syncVars() {
  const r = ratio();
  const dh = window.innerHeight / r;
  const root = document.documentElement.style;
  root.setProperty('--dh', `${dh.toFixed(2)}px`);
  root.setProperty('--stage-k', isMobile() ? '1' : Math.min(1, dh / STAGE_H).toFixed(4));
}

export function syncBodyHeight() {
  if (!wrapper) return;
  const h = wrapper.offsetHeight * ratio();
  document.body.style.height = `${Math.ceil(h)}px`;
}

function libScale() {
  // lib chỉ gán window.$ (không có window.jQuery)
  const $ = window.jQuery || window.$;
  if ($ && $.fn && $.fn.scalePlatform) $('#MS__wrapper, .MS__outer').scalePlatform();
}

export function initScale() {
  wrapper = document.getElementById('MS__wrapper');
  libScale();
  syncVars();
  syncBodyHeight();
  document.documentElement.classList.add('is-scaled');

  // lib tự bind resize → scalePlatform; handler này đăng ký sau nên chạy sau lib
  const resync = () => {
    syncVars();
    syncBodyHeight();
  };
  window.addEventListener('resize', debounce(resync, 60));
  // lib scale lại lúc window.load (reset style body) → đồng bộ lại sau đó
  if (document.readyState !== 'complete') window.addEventListener('load', () => requestAnimationFrame(resync), { once: true });

  if (wrapper && 'ResizeObserver' in window) {
    const ro = new ResizeObserver(debounce(syncBodyHeight, 50));
    Array.from(wrapper.children).forEach((child) => ro.observe(child));
  }

  // lib gỡ hẳn phần tử .MS__pc/.MS__mb lúc tải → đổi qua lại PC/MB thì phải tải lại trang
  mqMobile.addEventListener('change', debounce(() => window.location.reload(), 250));
}
